import axios from 'axios';
import { UserProfile, UserProgressItem, TrainingHistory } from '../types/user';

export const USER_ID_KEY = 'judoUserId';

function authHeaders() {
  const token = btoa(`${process.env.REACT_APP_API_USERNAME}:${process.env.REACT_APP_API_PASSWORD}`);
  return { Authorization: `Basic ${token}` };
}

const base = () => process.env.REACT_APP_API_URL;

export const userService = {
  async getUser(id: string): Promise<UserProfile> {
    const res = await axios.get<UserProfile>(`${base()}/User/${id}`, {
      headers: authHeaders(),
    });
    return res.data;
  },

  async login(username: string, pin: string): Promise<UserProfile> {
    const res = await axios.post<UserProfile>(
      `${base()}/User/login`,
      { username, pin },
      { headers: authHeaders() }
    );
    return res.data;
  },

  async createUser(username: string, pin: string): Promise<UserProfile> {
    const res = await axios.post<UserProfile>(
      `${base()}/User`,
      { username, pin },
      { headers: authHeaders() }
    );
    return res.data;
  },

  async recordTraining(id: string, xpEarned: number): Promise<UserProfile> {
    const res = await axios.put<UserProfile>(
      `${base()}/User/${id}/training`,
      { xpEarned },
      { headers: authHeaders() }
    );
    return res.data;
  },

  async getProgress(userId: string): Promise<UserProgressItem[]> {
    const res = await axios.get<UserProgressItem[]>(`${base()}/User/${userId}/Progress`, {
      headers: authHeaders(),
    });
    return res.data;
  },

  async getTrainingDays(userId: string): Promise<TrainingHistory> {
    const res = await axios.get<TrainingHistory>(
      `${base()}/User/${userId}/TrainingDays`,
      { headers: authHeaders() }
    );
    return res.data;
  },

  /** Records one correct answer for a curriculum item, incrementing its MasteryLevel by 1 (max 5). */
  async incrementProgress(userId: string, curriculumId: string): Promise<UserProgressItem> {
    const res = await axios.post<UserProgressItem>(
      `${base()}/User/${userId}/Progress`,
      { curriculumId },
      { headers: authHeaders() }
    );
    return res.data;
  },
};
